// tapCountMutation.js
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { sendTapCounts } from '../../api/UserRequest';

export const useSendTapCounts = () => {
    const queryClient = useQueryClient();

    const mutationFn = async ({ cardID, tapCounts }) => {
        // const response = await axios.post('/api/tap-counts', tapCounts);
        // return response.data;

        // console.log(tapCounts, cardID, 'tapCounts in mutation');

        const { data } = await sendTapCounts(cardID, tapCounts)
        return data
    };

    return useMutation({
        mutationFn,
        onError: (error, variables, context) => {
            // An error happened!
            console.error('Error sending data:', error);
            console.log(`rolling back optimistic update with id ${context.id}`)
        },
        onSuccess: (data, variables, context) => {
            // Boom baby!
            console.log('Data sent successfully');
            queryClient.setQueryData('tapCounts', {});

            // Clear the cookie after successful data transmission
            clearTapCountsCookie();
        },
        retry: 3,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),

    })
};

const setTapCountsCookie = (tapCounts) => {
    document.cookie = `tapCounts=${encodeURIComponent(JSON.stringify(tapCounts))}; path=/;`;
};

const getTapCountsFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )tapCounts=([^;]+)'));
    return match ? JSON.parse(decodeURIComponent(match[2])) : null;
};

const clearTapCountsCookie = () => {
    document.cookie = 'tapCounts=; Max-Age=0; path=/;';
};

// export const useSendTapCounts = () => {
//     const queryClient = useQueryClient();

//     const mutationFn = async (tapCounts) => {
//       const response = await axios.post('/api/tap-counts', tapCounts);
//       return response.data;
//     };

//     return useMutation(mutationFn, {
//       onError: (error, variables, context) => {
//         console.error('Error sending data:', error);
//         console.log(`rolling back optimistic update with id ${context.id}`);
//       },
//       onSuccess: (data, variables, context) => {
//         console.log('Data sent successfully');
//         queryClient.setQueryData('tapCounts', {});
//       },
//       retry: 3,
//       retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
//     });
//   };

// export const updateTapCount = (queryClient, button) => {
//     const currentCounts = queryClient.getQueryData('tapCounts') || {};
//     queryClient.setQueryData('tapCounts', {
//         ...currentCounts,
//         [button]: (currentCounts[button] || 0) + 1,
//     });
// };

// Function to update tap counts with location data
export const updateTapCount = async (queryClient, button, id) => {
    // Get the current tap counts from the cache
    const currentCounts = queryClient.getQueryData('tapCounts') || getTapCountsFromCookie() || {};

    // Fetch the current location data using the IP API
    // const liveLocation = await axios.get('https://ipapi.co/json');
    const liveLocation = await axios.get(`https://ipapi.co/json/?key=${process.env.REACT_APP_API_IPAPI_KEY}`)

    const locationData = {
        ip: liveLocation.data.ip,
        city: liveLocation.data.city,
        region: liveLocation.data.region,
        country: liveLocation.data.country_name,
        timeLog: Date.now(),
    };


    // console.log(id, 'tppppppppppppp id');

    if (id) {

        /* ----------------------------- maked as object ----------------------------- */

        // // Initialize button data if not present
        // if (!currentCounts[button]) {
        //     currentCounts[button] = {};
        // }

        // if (!currentCounts[button][id]) {
        //     currentCounts[button][id] = { taps: 0, location: [] };
        // }


        // // Increment the tap count
        // currentCounts[button][id].taps += 1;

        // // Check if the location already exists in the location array
        // const existingLocationIndex = currentCounts[button][id].location.findIndex(
        //     (loc) =>
        //         loc.ip === locationData.ip &&
        //         loc.city === locationData.city &&
        //         loc.region === locationData.region &&
        //         loc.country === locationData.country
        // );

        // if (existingLocationIndex !== -1) {
        //     // Update existing location data
        //     currentCounts[button][id].location[existingLocationIndex].count += 1;
        //     currentCounts[button][id].location[existingLocationIndex].timeLog.push(Date.now());
        // } else {
        //     // Add new location data
        //     currentCounts[button][id].location.push({ ...locationData, count: 1, timeLog: [Date.now()] });
        // }


        /* ----------------------------- maked as array ----------------------------- */
        // Initialize button data if not present
        if (!currentCounts[button]) {
            currentCounts[button] = [];
        }

        // Find the index of the entry with the matching id
        let entryIndex = currentCounts[button].findIndex((entry) => entry.id === id);

        if (entryIndex === -1) {
            // If the entry does not exist, create it
            currentCounts[button].push({ id, taps: 0, location: [] });
            entryIndex = currentCounts[button].length - 1;
        }

        // Increment the tap count for the specific entry
        currentCounts[button][entryIndex].taps += 1;

        // Check if the location already exists in the location array
        const existingLocationIndex = currentCounts[button][entryIndex].location.findIndex(
            (loc) =>
                loc.ip === locationData.ip &&
                loc.city === locationData.city &&
                loc.region === locationData.region &&
                loc.country === locationData.country
        );

        if (existingLocationIndex !== -1) {
            // Update existing location data
            currentCounts[button][entryIndex].location[existingLocationIndex].count += 1;
            currentCounts[button][entryIndex].location[existingLocationIndex].timeLog.push(Date.now());
        } else {
            // Add new location data
            currentCounts[button][entryIndex].location.push({ ...locationData, count: 1, timeLog: [Date.now()] });
        }

    } else {
        // Initialize button data if not present
        if (!currentCounts[button]) {
            currentCounts[button] = { taps: 0, location: [] };
        }

        // Increment the tap count
        currentCounts[button].taps += 1;

        // Check if the location already exists in the location array
        const existingLocationIndex = currentCounts[button].location.findIndex(
            (loc) =>
                loc.ip === locationData.ip &&
                loc.city === locationData.city &&
                loc.region === locationData.region &&
                loc.country === locationData.country
        );

        if (existingLocationIndex !== -1) {
            // Update existing location data
            currentCounts[button].location[existingLocationIndex].count += 1;
            currentCounts[button].location[existingLocationIndex].timeLog.push(Date.now());
        } else {
            // Add new location data
            currentCounts[button].location.push({ ...locationData, count: 1, timeLog: [Date.now()] });
        }
    }


    // Update the cache with the new data
    queryClient.setQueryData('tapCounts', currentCounts);


    // Store the tapCounts in a cookie
    setTapCountsCookie(currentCounts);


};

export const getTapCounts = (queryClient) => {
    return queryClient.getQueryData('tapCounts') || getTapCountsFromCookie() || {};
};
